
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beachful-pro",
      function () {
        return require("private-next-pages/beachful-pro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beachful-pro"])
      });
    }
  